import styled from '@emotion/styled';

export const List = styled.ul`
  margin-bottom: 50px;
  max-width: 344px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;
`;
